import { ua as UA } from '@/utils/tools'

/**
 * 获得wx对象 自动加载js 并完成签名
 */
export const getWXQQSDK = () => {
  // 微信小程序存在误判钉钉小程序，优先返回钉钉小程序
  if (UA.ddminiprogram) { return window.dd }
  if (UA.qqminiprogram) { return window.qq }
  if (UA.wxminiprogram) { return window.wx }
  if (UA.aliyunDisk) { return window.aliDriveJSAPI }
  return window.wx
}
